import * as React from 'react';
import { connect } from 'react-redux';
import { config } from '../../config';
import { ICompanyTermsReducer } from '../../reducers/companyTerms';
import { IPageDataReducer } from '../../reducers/pageData';
import { FAQContact } from '../FAQ/components/FAQContact';

const style: Record<string, React.CSSProperties> = {
    wrapper: {
        paddingLeft: 10,
        paddingRight: 10,
    },
};

interface StateProps {
    pageData: IPageDataReducer;
    companyTerms: ICompanyTermsReducer;
    phoneNumber: string;
    countryCode: string;
}

interface DistpachProps {}

type Props = StateProps & DistpachProps;

class CompanyTermsDetailClass extends React.Component<Props, {}> {
    render() {
        const { cmsData } = this.props.companyTerms;

        const { deviceType } = this.props.pageData;

        const isDesktop = deviceType === 'desktop';

        const Header = () => {
            const style = {
                header: {
                    backgroundImage: `url(${config.images}/common/faq_contact_background.jpg)`,
                },
            };
            return (
                <div className="standardContentPage--header" style={style.header}>
                    <div className="standardContentPage--header-overlay" />
                    <div className="standardContentPage--header-data">
                        <h1 className="roundtrip-responsive">{cmsData.title}</h1>
                    </div>
                </div>
            );
        };

        if (isDesktop) {
            return (
                <>
                    <Header />
                    <div className="standardContentPage--container">
                        <FAQContact
                            countryCode={this.props.countryCode}
                            phoneNumber={this.props.phoneNumber}
                            contactPageUrl={this.props?.pageData?.brandConfig?.contactPagePath}
                        />
                        <div className="standardContentPage--content">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: this.props.companyTerms.companyTerms,
                                }}
                                style={style.wrapper}
                            />
                        </div>
                    </div>
                </>
            );
        }

        return (
            <div
                dangerouslySetInnerHTML={{ __html: this.props.companyTerms.companyTerms }}
                style={style.wrapper}
            />
        );
    }
}
const mapStateToProps = (state: StateProps) => ({
    pageData: state.pageData,
    companyTerms: state.companyTerms,
    phoneNumber: state.pageData.brandConfig.phoneNumber,
    countryCode: state.pageData.appConfig.countryCode,
});
export const CompanyTermsDetail = connect<StateProps, DistpachProps, any>(
    mapStateToProps,
    {},
)(CompanyTermsDetailClass);

export default CompanyTermsDetail;
